import { useState } from "react";
import { DatePicker } from "react-rainbow-components";
import styled from "styled-components";
import { useSelector } from "react-redux/es/exports";

import { TbArrowsLeftRight } from "react-icons/tb";
import { BsPlusLg } from "react-icons/bs";
import { AiOutlineMinus } from "react-icons/ai";
import Support from "../components/Supports";
import { selectHotel } from "../redux/FaqSlice";
import Faq from "../components/FAQ";
import { Helmet } from "react-helmet";

import { Inputs } from "./TrainTicket";
import { DatePickers } from "./TrainTicket";
import { Passengers } from "./TrainTicket";

const HotelReserve = () => {
  const [date, setDate] = useState(new Date());
  const [isoneWay, setIsOneWay] = useState("single");
  const [adult, setAdult] = useState(1);
  const [child, setChild] = useState(0);
  const [isHidden , setIsHidden] = useState (true)

  const passengers = document.getElementById("passengers");
  let allPassengers = adult + child;

  let questions = useSelector(selectHotel);

  let FaqElems = questions.map((question) => {
    return Object.entries(question)[1];
  });

  const addAdult = () => {
    setAdult(adult + 1);
  };
  const minuseAdult = () => {
    if (adult == 1) {
      return;
    }
    setAdult(adult - 1);
  };
  const addChild = () => {
    setChild(child + 1);
  };
  const minuseChild = () => {
    if (child == 0) {
      return;
    }
    setChild(child - 1);
  };

  const passengerNum = () => {
  setIsHidden(!isHidden)
  };
  return (
    <>
      <Helmet>
        <title>رزرو هتل</title>
      </Helmet>

      <Inputs>
        <input
          type="text"
          placeholder="مقصد یا هتل (داخلی یا خارجی)"
          className="textInput"
          style={{ paddingRight: "25px"  , width:'250px'}}
        />

        <DatePickers
          value={date}
          name="انتخاب تاریخ سفر"
          placeholder="انتخاب تاریخ سفر"
          onChange={(value) => setDate(value)}
          selectionType={isoneWay}
          label="انتخاب تاریخ سفر"
        />

        <section className="inputRule" onClick={passengerNum} style={{width: '200px'}}>
          {`${adult} بزرگسال , ${child} کودک`}
          <label>مسافران</label>
        </section>

        <button className="searchButton">جستجو</button>

        <Passengers id="passengers" className={isHidden ? 'hidden' : null}>
          <div className="chooseNum">
            <section>
              <p>
                بزرگسال <span>( 12 سال به بالا)</span>
              </p>
              <section>
                <span className="NumButton" onClick={addAdult}>
                  <BsPlusLg />
                </span>
                <span className="ShowNum">{adult}</span>
                <span className="NumButton" onClick={minuseAdult}>
                  <AiOutlineMinus />
                </span>
              </section>
            </section>
            <section>
              <p>
                کودک <span>( تا 12 سال)</span>
              </p>
              <section>
                <span className="NumButton" onClick={addChild}>
                  <BsPlusLg />
                </span>
                <span className="ShowNum">{child}</span>
                <span className="NumButton" onClick={minuseChild}>
                  <AiOutlineMinus />
                </span>
              </section>
            </section>
          </div>
        </Passengers>
      </Inputs>

      <Support />

      <Faq FaqElems={FaqElems} />
    </>
  );
};

export default HotelReserve;

